import script from "./NewChild.vue?vue&type=script&setup=true&lang=js"
export * from "./NewChild.vue?vue&type=script&setup=true&lang=js"

import "./NewChild.vue?vue&type=style&index=0&id=f82b5c40&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f82b5c40"]])

export default __exports__